import React from 'react';
import styles from './Section.module.css';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'primary' | 'secondary' | 'tertiary';
  padding?: 'none' | 'small' | 'medium' | 'large';
}

export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  background = 'primary',
  padding = 'large',
}) => {
  return (
    <section className={`${styles.section} ${styles[background]} ${styles[padding]} ${className}`}>
      <div className={styles.container}>
        {children}
      </div>
    </section>
  );
};

